// extracted by mini-css-extract-plugin
module.exports = {"zombie-purge-list-checkbox-box":"ZombiePurgeCheckbox_zombie-purge-list-checkbox-box__m7Q8m"};